import React from 'react';

export const BackgroundDots: React.FC<{
    count: number;
    activeIndex: number;
    onSelect: (index: number) => void;
}> = ({ count, activeIndex, onSelect }) => {
    return (
        <div className="bgDots" aria-label="Výběr fotky na pozadí">
            {Array.from({ length: count }).map((_, index) => {
                const isActive = index === activeIndex;
                return (
                    <button
                        key={index}
                        type="button"
                        className={`bgDot${isActive ? ' bgDotActive' : ''}`}
                        aria-label={`Zvolit fotku ${index + 1} z ${count}`}
                        aria-current={isActive ? 'true' : undefined}
                        onClick={() => onSelect(index)}
                    />
                );
            })}
        </div>
    );
};
